var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeOffOutline = function SvgEyeOffOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m14.024 9.976-4.048 4.048a2.862 2.862 0 1 1 4.048-4.048Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.656 7.016c-1.4-1.056-3-1.632-4.656-1.632-2.824 0-5.456 1.664-7.288 4.544-.36.563-1.54 1.317-1.54 2.072 0 .757 1.18 1.515 1.54 2.08a11.461 11.461 0 0 0 2.168 2.536m2.256 1.408c.912.384 1.88.592 2.864.592 2.824 0 5.456-1.664 7.288-4.544.36-.563 1.54-1.317 1.54-2.072 0-.757-1.18-1.515-1.54-2.08a12.977 12.977 0 0 0-.848-1.176"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.808 12.56a2.852 2.852 0 0 1-2.256 2.256m-2.576-.792L4 20M20 4l-5.976 5.976"
  })));
};
export default SvgEyeOffOutline;